const locale = {
  ALL: 'Todos',
  SPECIALIZED: 'Especializadas',
  HUMAN: 'Humanas',
};

export default locale;
